import {Injectable} from '@angular/core';
import {CatalogService} from '../../pim/catalog/catalog.service';

@Injectable({
  providedIn: 'root'
})
export class DamCatalogService extends CatalogService {
  apiUrl = '/dam-menu';
}
